'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Keep state for controlled components

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _primitives = require('./primitives');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FieldLabel = require('./FieldLabel');

var _FieldLabel2 = _interopRequireDefault(_FieldLabel);

var _FieldValue = require('./FieldValue');

var _FieldValue2 = _interopRequireDefault(_FieldValue);

var _FieldInfo = require('./FieldInfo');

var _FieldInfo2 = _interopRequireDefault(_FieldInfo);

var _FieldError = require('./FieldError');

var _FieldError2 = _interopRequireDefault(_FieldError);

var _field = require('./field');

var _field2 = _interopRequireDefault(_field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getField = exports.getField = function getField(fields, name) {
  var namePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  // console.log('getting Field:', namePrefix, name)


  if (!fields) {
    return null;
  }
  var useName = namePrefix || "";
  if (useName) {
    useName += ".";
  }
  useName += name;
  var tree = useName.replace(/\]/g, '').split(/[\.\[]/);

  if (tree.length == 1) {
    if (!fields[tree[0]] && (fields.config || fields.arrayOfType)) {
      if (fields.config && fields.type === "keyvalue") {
        return fields.config[tree[0]];
      }
      if (fields.config) {
        return fields.config;
      }
      if (fields.arrayOfType && fields.type === "fieldarray") {
        var newFields = _extends({}, fields, { type: fields.arrayOfType });
        return newFields;
      }
    } else {
      // console.log(tree[0], fields[tree[0]])
      return fields[tree[0]];
    }
  } else {
    if (fields[name]) {
      // console.log(name, fields[name])
      return fields[name];
    } else {
      if (!fields[tree[0]] && (fields.config || fields.arrayOfType)) {
        // console.log(fields)
        if (fields.config) {
          return getField(fields.config, tree.slice(1).join('.'));
        }
        if (fields.arrayOfType && fields.type === "fieldarray") {
          var _newFields = _extends({}, fields, { type: fields.arrayOfType });
          return getField(_newFields, tree.slice(1).join('.'));
        }
      } else {
        return getField(fields[tree[0]], tree.slice(1).join('.'));
      }
    }
  }
};

var FormField = function (_Component) {
  _inherits(FormField, _Component);

  function FormField(props, context) {
    _classCallCheck(this, FormField);

    var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props, context));

    _this.onChange = function (newValue) {
      _this.setState({ value: newValue });
    };

    _this.state = {
      value: null
    };
    return _this;
  }

  _createClass(FormField, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        name: this.props.name,
        onChange: this.onChange
      };
    }
  }, {
    key: 'getFieldMode',
    value: function getFieldMode(field) {
      var _props = this.props,
          mode = _props.mode,
          input = _props.input,
          value = _props.value,
          display = _props.display;

      if (field && field.displayOnly) {
        return "display";
      }
      if (mode || input || value || display) {
        if (mode) {
          return mode;
        } else {
          if (input === true) {
            return "input";
          } else if (value === true) {
            return "value";
          } else {
            return "display";
          }
        }
      } else {
        if (this.context.mode === "add" || this.context.mode === "edit") {
          return "input";
        } else {
          return "display";
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          noLabel = _props2.noLabel,
          labelProps = _props2.labelProps,
          valueProps = _props2.valueProps,
          inputProps = _props2.inputProps,
          infoProps = _props2.infoProps,
          errorProps = _props2.errorProps,
          name = _props2.name,
          children = _props2.children,
          renderField = _props2.renderField,
          renderLabel = _props2.renderLabel,
          renderValue = _props2.renderValue,
          renderInput = _props2.renderInput,
          renderError = _props2.renderError,
          renderInfo = _props2.renderInfo,
          validate = _props2.validate,
          type = _props2.type,
          autoFocus = _props2.autoFocus,
          label = _props2.label,
          displayOnly = _props2.displayOnly,
          onChange = _props2.onChange,
          onBlur = _props2.onBlur;


      var drillProps = {
        autoFocus: autoFocus
      };

      if (onChange) {
        inputProps.onChange = onChange;
      }

      if (onBlur) {
        inputProps.onBlur = onBlur;
      }

      if (validate) {
        drillProps.validate = validate;
      }

      if (type) {
        drillProps.type = type;
      }

      if (label) {
        drillProps.label = label;
      }

      var _context = this.context,
          fields = _context.fields,
          namePrefix = _context.namePrefix;


      var field = getField(fields, name, namePrefix) || {};

      if (!children || children.length === 0) {
        var DrawField = renderField || this.context.renderField;

        var mode = displayOnly ? "display" : this.getFieldMode(field);

        return _react2.default.createElement(DrawField, {
          mode: mode,
          Label: function Label(props) {
            return !noLabel && _react2.default.createElement(_FieldLabel2.default, _extends({ name: name, renderLabel: renderLabel }, labelProps, drillProps, props));
          },
          Value: function Value(props) {
            return _react2.default.createElement(_FieldValue2.default, _extends({ name: name }, valueProps, { renderValue: renderValue, noLabel: noLabel }, drillProps, props));
          },
          Input: function Input(props) {
            return _react2.default.createElement(_FieldValue2.default, _extends({ name: name }, inputProps, { renderInput: renderInput, noLabel: noLabel }, drillProps, props));
          },
          Err: function Err(props) {
            return _react2.default.createElement(_FieldError2.default, _extends({ name: name }, errorProps, { renderError: renderError }, drillProps, props));
          },
          Info: function Info(props) {
            return _react2.default.createElement(_FieldInfo2.default, _extends({ name: name }, infoProps, { renderInfo: renderInfo }, drillProps, props));
          },
          Warning: function Warning(props) {
            return _react2.default.createElement(_FieldInfo2.default, _extends({ name: name }, infoProps, { renderInfo: renderInfo }, drillProps, props));
          }
        });
      } else {
        return children;
      }
    }
  }]);

  return FormField;
}(_react.Component);

FormField.propsTypes = {
  name: _propTypes2.default.string.isRequired,
  noLabel: _propTypes2.default.bool,
  labelProps: _propTypes2.default.object,
  valueProps: _propTypes2.default.object,
  renderField: _propTypes2.default.func,
  renderLabel: _propTypes2.default.func,
  renderValue: _propTypes2.default.func,
  renderInput: _propTypes2.default.func,
  renderError: _propTypes2.default.func,
  renderInfo: _propTypes2.default.func,
  display: _propTypes2.default.bool,
  input: _propTypes2.default.bool,
  value: _propTypes2.default.bool,
  mode: _propTypes2.default.string
};

FormField.defaultProps = {
  noLabel: false,
  labelProps: {},
  valueProps: {},
  display: null,
  input: null,
  value: null,
  mode: null,
  renderField: null
};

FormField.contextTypes = {
  fields: _propTypes2.default.object,
  mode: _propTypes2.default.string,
  renderField: _propTypes2.default.func,
  namePrefix: _propTypes2.default.string
};

FormField.childContextTypes = {
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

exports.default = FormField;